import React from 'react';

import { Registration } from '../../../../hooks/api/utils/types';
import RegistrationFrequentPassageRequests from '../../../shared/frequentPassageRequests/RegistrationFrequentPassageRequests';

type Props = {
  registration: Registration;
};

export default function FrequentPassages({ registration }: Props) {
  return <RegistrationFrequentPassageRequests registration={registration} admin />;
}
